export default __webpack_public_path__ + "static/media/pic1.6a428370.jpg";